// Tesseron icon set (ported from the prototype's `Icons`): normalized
// 24x24, stroke 1.5, round caps/joins, no fill. Export names are kept stable so
// every existing consumer swaps to the shared look without code changes.
// `size` controls width/height; color is inherited via `stroke="currentColor"`.
//
// This is the ONLY icon module. It also hosts:
//   • the compact glyphs merged from the former `glyphs.jsx` (default size 16),
//   • a 16-grid family (viewBox 0 0 16 16, stroke 1.4) used by the detail
//     heads — kept on their native grid for pixel parity with the original
//     inline drawings.
// Where CSS sizes/strokes an icon (e.g. `.dd-iconbtn svg`, `.pg-dl`), the CSS
// wins over these attribute defaults — same as with the old inline svgs.

function Svg({ size = 18, children, ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {children}
    </svg>
  );
}

export function NotificationsOutlined({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6" />
      <path d="M10 19a2 2 0 0 0 4 0" />
    </Svg>
  );
}

export function HomeOutlinedIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M3 10.5 12 3l9 7.5M5 9.5V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.5" />
    </Svg>
  );
}

export function GavelOutlinedIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="m14 13-7.5 7.5a2.1 2.1 0 0 1-3-3L11 10" />
      <path d="m16 16 6-6" />
      <path d="m8 8 6-6" />
      <path d="m9 7 4 4" />
      <path d="m17 11 4 4" />
    </Svg>
  );
}

export function AssignmentOutlinedIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M14 3v4a1 1 0 0 0 1 1h4" />
      <path d="M5 3h9l5 5v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1Z" />
      <path d="M9 13h6M9 17h4" />
    </Svg>
  );
}

export function PaymentsOutlinedIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M19 7V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-2" />
      <path d="M21 9v6h-5a3 3 0 0 1 0-6Z" />
    </Svg>
  );
}

export function InboxOutlinedIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M4 7h16v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Z" />
      <path d="M4 13h4l1.5 2h5L16 13h4" />
    </Svg>
  );
}

export function DescriptionIcon({ size = 18, ...props }) {
  // Facturación → receipt (Finanzas glyph).
  return (
    <Svg size={size} {...props}>
      <path d="M5 3v18l2.5-1.5L10 21l2-1.5L14 21l2.5-1.5L19 21V3l-2.5 1.5L14 3l-2 1.5L10 3 7.5 4.5 5 3Z" />
      <path d="M8 8h8M8 12h8M8 16h5" />
    </Svg>
  );
}

export function PersonOutlineOutlinedIcon({ size = 18, ...props }) {
  // Receptores → users (the directory of people).
  return (
    <Svg size={size} {...props}>
      <path d="M16 19v-2a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v2" />
      <circle cx="9.5" cy="8" r="3" />
      <path d="M21 19v-2a3 3 0 0 0-2.3-2.9M15 5.1A3 3 0 0 1 15 11" />
    </Svg>
  );
}

export function BusinessOutlinedIcon({ size = 18, ...props }) {
  // Tribunales → scale of justice (nav icon).
  return (
    <Svg size={size} {...props}>
      <path d="M12 3v18M7 21h10M6 7h12M6 7 3 13a3 3 0 0 0 6 0Zm12 0-3 6a3 3 0 0 0 6 0Z" />
      <path d="M12 4 6 7M12 4l6 3" />
    </Svg>
  );
}

export function HelpOutlineIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.2 9.5a2.8 2.8 0 0 1 5.4 1c0 1.8-2.6 2.2-2.6 4M12 17.5v.4" />
    </Svg>
  );
}

export function ChevronLeftIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="m15 6-6 6 6 6" />
    </Svg>
  );
}

export function ChevronRightIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="m9 6 6 6-6 6" />
    </Svg>
  );
}

export function CloseIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M6 6l12 12M18 6 6 18" />
    </Svg>
  );
}

export function DownloadIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M12 3v12m0 0 4-4m-4 4-4-4" />
      <path d="M4 17v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2" />
    </Svg>
  );
}

export function DeleteIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13M10 11v6M14 11v6" />
    </Svg>
  );
}

export function MinimizeIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M5 12h14" />
    </Svg>
  );
}

export function BugReportIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <rect x="8" y="7" width="8" height="11" rx="4" />
      <path d="M9 4l1.5 2.2M15 4l-1.5 2.2M3 10h3M18 10h3M2.5 15H6M18 15h3.5M3.5 20l3-2M20.5 20l-3-2" />
    </Svg>
  );
}

// Single person — account menu "Mi cuenta" (`user` glyph).
export function UserIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <circle cx="12" cy="8" r="3.2" />
      <path d="M5 20a7 7 0 0 1 14 0" />
    </Svg>
  );
}

// Settings cog — account menu "Preferencias". A real toothed gear (the
// previous `gear` glyph was a circle + straight rays that read as a sun).
export function GearIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </Svg>
  );
}

// Sun / Moon — topbar theme toggle (`sun`/`moon` glyphs; the repo used the
// unicode ☀/☾ glyphs, which don't match the prototype's stroke icons).
export function SunIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
    </Svg>
  );
}

export function MoonIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M21 12.8A8.5 8.5 0 1 1 11.2 3a6.5 6.5 0 0 0 9.8 9.8Z" />
    </Svg>
  );
}

// Sign-out — account menu "Cerrar sesión" (`logout` glyph).
export function LogoutIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M14 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4" />
      <path d="M10 12H3m0 0 3.5-3.5M3 12l3.5 3.5" />
    </Svg>
  );
}

// Two-way arrows — account menu "Cambiar de organización" (`swap` glyph).
export function SwapIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M7 4 3 8l4 4" />
      <path d="M3 8h13a3 3 0 0 1 0 6h-1" />
      <path d="m17 20 4-4-4-4" />
      <path d="M21 16H9" />
    </Svg>
  );
}

// Office building — account menu "Ver estudio" (`building` glyph).
export function BuildingIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M5 21V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v17" />
      <path d="M15 9h3a1 1 0 0 1 1 1v11M3 21h18M8 7h2M8 11h2M8 15h2" />
    </Svg>
  );
}

// Envelope — support email channel (`mail` glyph).
export function MailIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m4 7 8 5.5L20 7" />
    </Svg>
  );
}

// Handset — support phone channel (`phone` glyph).
export function PhoneIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </Svg>
  );
}

// Speech bubble — support WhatsApp channel (`chat` glyph).
export function ChatBubbleIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
    </Svg>
  );
}

// ── Compact glyphs (merged from the former `glyphs.jsx`) ────────────────────
// Same 24-grid stroke language; they keep their historical default size (16)
// so every former glyphs consumer renders identically.
// Dedupe note: glyphs' `X` → `CloseIcon`, `ChevronLeft`/`ChevronRight` →
// `ChevronLeftIcon`/`ChevronRightIcon` (same drawings; the *Icon names won).

export function Search({ size = 16, ...props }) {
  return (
    <Svg size={size} {...props}>
      <circle cx="11" cy="11" r="7" />
      <path d="M21 21l-4.3-4.3" />
    </Svg>
  );
}

export function ChevronDown({ size = 16, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M6 9l6 6 6-6" />
    </Svg>
  );
}

export function Plus({ size = 16, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M12 5v14M5 12h14" />
    </Svg>
  );
}

export function Upload({ size = 16, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M12 16V4M7 9l5-5 5 5" />
      <path d="M5 20h14" />
    </Svg>
  );
}

export function ArrowRight({ size = 16, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M5 12h14M13 6l6 6-6 6" />
    </Svg>
  );
}

export function Filter({ size = 16, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M3 5h18l-7 8v5l-4 2v-7L3 5z" />
    </Svg>
  );
}

// Wallet — list/chip glyph (24-grid). The detail heads use `WalletIcon`
// (16-grid variant below); the drawings differ, so both stay.
export function Wallet({ size = 16, ...props }) {
  return (
    <Svg size={size} {...props}>
      <rect x="3" y="6" width="18" height="13" rx="2" />
      <path d="M3 10h18M16 14h2" />
    </Svg>
  );
}

export function Cube({ size = 16, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M21 8l-9-5-9 5v8l9 5 9-5V8z" />
      <path d="M3 8l9 5 9-5M12 13v8" />
    </Svg>
  );
}

export function Columns({ size = 16, ...props }) {
  return (
    <Svg size={size} {...props}>
      <rect x="3" y="4" width="18" height="16" rx="1" />
      <path d="M9 4v16M15 4v16" />
    </Svg>
  );
}

// ── Alert / status glyphs (24-grid) ─────────────────────────────────────────
// Used inside `.rx__alert` / `.cod-alert`, whose CSS sets size + stroke.

export function InfoIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v5M12 7.6h.01" />
    </Svg>
  );
}

export function WarnIcon({ size = 18, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
    </Svg>
  );
}

// ── Eye toggles — password show/hide (24-grid, stroke 2, 16px default) ─────

export function EyeIcon({ size = 16, ...props }) {
  return (
    <Svg size={size} strokeWidth="2" {...props}>
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </Svg>
  );
}

export function EyeOffIcon({ size = 16, ...props }) {
  return (
    <Svg size={size} strokeWidth="2" {...props}>
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </Svg>
  );
}

// ── 16-grid family ──────────────────────────────────────────────────────────
// Drawn on a 16×16 grid (stroke 1.4 @ 15px — the detail heads' language).
// Kept on their native grid so the rendered pixels match the original inline
// drawings exactly. Inside `.dd-iconbtn` the CSS (viewBox-16 units) applies.

export function RefreshIcon({ size = 15, ...props }) {
  return (
    <Svg size={size} viewBox="0 0 16 16" strokeWidth="1.4" {...props}>
      <path d="M13.2 7a5.2 5.2 0 10-.8 4" />
      <path d="M13.4 3v3.2h-3.2" />
    </Svg>
  );
}

export function SendIcon({ size = 15, ...props }) {
  return (
    <Svg size={size} viewBox="0 0 16 16" strokeWidth="1.4" {...props}>
      <path d="M14 2 7 9M14 2l-4.5 12-2.5-5-5-2.5L14 2z" />
    </Svg>
  );
}

// Arrow out (↗) — "ver causa" jump from the diligencia detail.
export function ArrowUpRightIcon({ size = 15, ...props }) {
  return (
    <Svg size={size} viewBox="0 0 16 16" strokeWidth="1.4" {...props}>
      <path d="M5.2 10.8 10.8 5.2M6.2 5.2h4.6v4.6" />
    </Svg>
  );
}

// WalletIcon — detail-head 16-grid variant of `Wallet` (drawing differs:
// card detail bottom-left vs clasp right). Kept for pixel parity.
export function WalletIcon({ size = 15, ...props }) {
  return (
    <Svg size={size} viewBox="0 0 16 16" strokeWidth="1.4" {...props}>
      <rect x="2" y="3.5" width="12" height="9" rx="1.5" />
      <path d="M2 6.5h12M4.5 10H7" />
    </Svg>
  );
}

// Reset / clear (↺) — form "limpiar" action (NuevaCausaForm).
export function ResetIcon({ size = 14, ...props }) {
  return (
    <Svg size={size} viewBox="0 0 16 16" strokeWidth="1.3" {...props}>
      <path d="M12.5 6.5A4.5 4.5 0 1 0 13 9M12.5 6.5V3.5M12.5 6.5h-3" />
    </Svg>
  );
}

// Copy-to-clipboard + its "copied" check (RightSidebar `.rsb__copy` pair —
// that CSS sets size and stroke).
export function CopyIcon({ size = 13, ...props }) {
  return (
    <Svg size={size} viewBox="0 0 16 16" {...props}>
      <rect x="5.5" y="5.5" width="8" height="8" rx="1.3" />
      <path d="M10.5 5.5V3.8a1.3 1.3 0 00-1.3-1.3H3.8a1.3 1.3 0 00-1.3 1.3v5.4a1.3 1.3 0 001.3 1.3h1.7" />
    </Svg>
  );
}

export function CheckIcon({ size = 13, ...props }) {
  return (
    <Svg size={size} viewBox="0 0 16 16" {...props}>
      <path d="M3.5 8.5 6.5 11.5 12.5 4.5" />
    </Svg>
  );
}

// Seal check — the offer-selection seal (`.pg-of__seal`, CSS-styled). Nearly
// identical drawing to CheckIcon but not a scalar match; kept for pixel
// parity. Dedupe candidate if a visual pass ever unifies them.
export function SealCheckIcon({ size = 11, ...props }) {
  return (
    <Svg size={size} viewBox="0 0 16 16" {...props}>
      <path d="M3 8.5l3.2 3L13 5" />
    </Svg>
  );
}
